// Single list of locales the site serves. English lives at the root with no prefix;
// the rest are routed under `:locale` (see routes.ts) and appear in the sitemap's
// hreflang alternates.
export const DEFAULT_LOCALE = "en";
export const NON_ENGLISH_LOCALES = ["fr-CA", "es"] as const;
export const SUPPORTED_LOCALES = [DEFAULT_LOCALE, ...NON_ENGLISH_LOCALES] as const;

/** The locale a URL path belongs to: its first segment when that is a non-English
 * locale ("/fr-CA/products/drive" -> "fr-CA"), otherwise English. */
export function localeFromPathname(pathname: string): string {
  const [, firstSegment] = pathname.split("/");
  return (NON_ENGLISH_LOCALES as readonly string[]).includes(firstSegment) ? firstSegment : DEFAULT_LOCALE;
}
